import { render, staticRenderFns } from "./JdsFieldLayout.vue?vue&type=template&id=10d6f27a&scoped=true&"
import script from "./JdsFieldLayout.vue?vue&type=script&lang=ts&"
export * from "./JdsFieldLayout.vue?vue&type=script&lang=ts&"
import style0 from "./JdsFieldLayout.vue?vue&type=style&index=0&id=10d6f27a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d6f27a",
  null
  
)

export default component.exports